import { ViewCheckbox } from "components/ui/atoms/Checkbox";
import { LabelValueForText } from "components/ui/atoms/LabelValue";
import { getCommons } from "./fieldConverterHelpers";

export const BooleanFieldView = ({ field, value }) => {
  return (
    <LabelValueForText
      label={field.label}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      value={<ViewCheckbox value={value} />}
      isMissing={value === undefined || value === null}
    />
  );
};

export const booleanFieldConverter = ({ field }) => {
  return {
    ...getCommons({ field }),
    type: "boolean",
  };
};
